import manifest from "@/data/image-manifest.json";

type Variant = { name: string; src: string; width: number; height: number };
type ImageAsset = { width: number; height: number; variants: Variant[] };
const assets: Readonly<Record<string, ImageAsset>> = manifest;

/** Width descriptors use actual pixel widths; small originals are never upscaled. */
export function responsiveImageSource(src: string, displayWidth?: number) {
  const asset = assets[src];
  if (!asset) return { src, srcSet: undefined, width: undefined, height: undefined };
  const unique = [...new Map(asset.variants.map(variant => [variant.width, variant])).values()].sort((a, b) => a.width - b.width);
  const fallback = displayWidth
    ? unique.find(variant => variant.width >= displayWidth) ?? unique[unique.length - 1]
    : asset.variants.find(variant => variant.name === "medium")!;
  return { src: fallback.src, srcSet: unique.map(variant => `${variant.src} ${variant.width}w`).join(", "), width: asset.width, height: asset.height };
}
